// Number of messages fetched at a time from Conversations SDK
export const MESSAGES_LOAD_COUNT = 20;

// The maximum number of characters allowed in message input
export const CHAR_LIMIT = 32 * 1024; // 32kB

// The height of the loading spinner box shown in the message list when fetching new messages
export const MESSAGES_SPINNER_BOX_HEIGHT = 50;

/*
 * Tempo fixo (ms) que o composer fica travado ao iniciar a conversa, cobrindo o carregamento do
 * fluxo de boas-vindas (com botões ou não). Timer fixo, não orientado a evento. 3s; suba se precisar.
 */
export const WELCOME_INPUT_LOCK_MS = 3000;
